/**
 * Wrap any route element to require authentication. Redirects to /auth on miss.
 * For role-gated routes, pass requireAppRole.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function AuthGuard({
  children,
  requireAppRole,
}: {
  children: ReactNode;
  requireAppRole?: 'admin' | 'moderator' | 'user';
}) {
  const { user, org, isLoaded } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return <div className="flex h-screen items-center justify-center text-muted-foreground">Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  if (requireAppRole && org?.appRole !== requireAppRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
